import { useCallback, useMemo } from "react";
import type { DashboardStatValue } from "../utils/dashboardViewModels";
import { areDashboardStatsEmpty, getDashboardStatValues } from "../utils/dashboardViewModels";
import { useStatisticData } from "./useStatisticData";

export interface DashboardStatistics {
  statValues: DashboardStatValue[];
  areStatsEmpty: boolean;
  hasData: boolean;
  loading: boolean;
  refreshing: boolean;
  error: string | null;
  retry: () => Promise<void>;
}

export const useDashboardStatistics = (): DashboardStatistics => {
  const statistics = useStatisticData();

  const statValues = useMemo(() => getDashboardStatValues(statistics.data), [statistics.data]);
  const areStatsEmpty = useMemo(() => areDashboardStatsEmpty(statistics.data), [statistics.data]);

  const { refetch: refetchStatistics } = statistics;

  const retry = useCallback(async () => {
    await refetchStatistics();
  }, [refetchStatistics]);

  return {
    statValues,
    areStatsEmpty,
    hasData: statistics.data !== null,
    loading: statistics.isLoading,
    refreshing: statistics.isRefreshing,
    error: statistics.error,
    retry,
  };
};
